export const SET_WOLT_DRIVER_INTEGRATIONS= 'SET_WOLT_DRIVER_INTEGRATIONS'
export const SET_WOLT_DRIVER_ERROR_VENUEID = 'SET_WOLT_DRIVER_ERROR_VENUEID'
export const SET_WOLT_DRIVER_ERROR_OTHER_FIELDS = 'SET_WOLT_DRIVER_ERROR_OTHER_FIELDS'
export const SET_WOLT_DRIVER_INTEGRATIONS_DELIVERY_PROMISES = 'SET_WOLT_DRIVER_INTEGRATIONS_DELIVERY_PROMISES'
export const SET_WOLT_DRIVER_NOT_FOUND = 'SET_WOLT_DRIVER_NOT_FOUND'
export const SET_WOLT_DRIVER_INTEGRATIONS_ORDER = 'SET_WOLT_DRIVER_INTEGRATIONS_ORDER'
